const config={
    apiSecret:'256650e87dd10b14cc2c41624e0ea.a6a7e55f6e2e0747ed4d64668f6c28e31ae2ca463e39cc2c1d5bb943f204e88c9c82f1b872c382c3fc50cb5ee30bb7199',
    baseUrl:'https://api.entity.hypersign.id'
}

export default config